import React, { ReactNode } from "react";
import styles from "@/css/Tooltip.module.css";

export const fieldInfoContent: {
  [key: string]: { title: string; content: ReactNode };
} = {
  // Vessel fields
  "vessel.DWT": {
    title: "Deadweight Tonnage (DWT)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>The Deadweight Tonnage.</pre>
      </div>
    ),
  },
  "vessel.lpp_m": {
    title: "Length Between Perpendiculars (Lpp)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The length between the foreside of the stem and the afterside of the
          rudder post at the vessel's summer loadline.
        </pre>
        <img
          src="https://officerofthewatch.com/wp-content/uploads/2012/02/figure-1-principal-dimensions1.jpg?w=536&h=202"
          alt="Lpp Diagram"
          style={{ width: "100%" }}
          className={styles.img}
        />
      </div>
    ),
  },
  "vessel.beam_m": {
    title: "Beam (B)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The width of the vessel at its widest point.
        </pre>
        <img
          src="/images/beam_diagram.png"
          alt="Beam Diagram"
          style={{ width: "100%" }}
          className={styles.img}
        />
      </div>
    ),
  },
  "vessel.draft_m": {
    title: "Draft (T)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The vertical distance between the waterline and the bottom of the hull
          (keel).
        </pre>
      </div>
    ),
  },
  "vessel.displacement_tons": {
    title: "Displacement (Δ)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The weight of water displaced by the ship's hull, equal to the
          vessel's mass. It's a key parameter in ship design and performance.
        </pre>
      </div>
    ),
  },
  "vessel.design_speed_kt": {
    title: "Design Speed",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The speed at which the vessel is designed to operate efficiently,
          measured in knots.
        </pre>
      </div>
    ),
  },
  // Fujiwara fields
  "wools.fujiwara.frontal_area_m2": {
    title: "Frontal Area (m²)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The area of the ship's frontal projection onto a plane perpendicular
          to the direction of motion.
        </pre>
      </div>
    ),
  },
  "wools.fujiwara.lateral_area_under_deck_m2": {
    title: "Lateral Area Under Deck (m²)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The lateral area of the ship below the deck level.
        </pre>
      </div>
    ),
  },
  "wools.fujiwara.lateral_area_over_deck_m2": {
    title: "Lateral Area Over Deck (m²)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The lateral area of the ship above the deck level.
        </pre>
      </div>
    ),
  },
  // Propulsion fields
  "wools.propulsion.nb_propellers": {
    title: "Number of Propellers",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The number of propellers installed on the vessel.
        </pre>
      </div>
    ),
  },
  "wools.propulsion.propeller.diameter_m": {
    title: "Propeller Diameter (m)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>The diameter of the propeller.</pre>
      </div>
    ),
  },
  "wools.propulsion.propeller.expanded_area_ratio": {
    title: "Expanded Area Ratio",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The ratio of the total blade area to the area of a circle with the
          propeller diameter.
        </pre>
      </div>
    ),
  },
  "wools.propulsion.propeller.design_pitch_ratio": {
    title: "Design Pitch Ratio",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The ratio of the propeller's pitch to its diameter.
        </pre>
      </div>
    ),
  },
  "wools.propulsion.propeller.nb_blades": {
    title: "Number of Blades",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The number of blades on the propeller.
        </pre>
      </div>
    ),
  },
  "wools.propulsion.rudder.mean_chord_m": {
    title: "Rudder Mean Chord (m)",
    content: (
      <div className={styles.content}>
        <pre className={styles.description}>
          The average chord length of the rudder.
        </pre>
      </div>
    ),
  },
  "wools.propulsion.rudder.span_length_m": {
    title: "Rudder Span Length (m)",
    content: "The vertical length (span) of the rudder.",
  },
};
